"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayPalService = void 0;
const apiRoutes_1 = require("../../utils/apiRoutes");
const Base_1 = require("../Base");
const excludeInvalidParams_1 = require("../../utils/excludeInvalidParams");
class PayPalService extends Base_1.BaseService {
    createOrder(accountId, data) {
        return this.request({
            url: (0, apiRoutes_1.createPayPalOrderUrl)(accountId),
            method: 'post',
            data,
        });
    }
    updateOrder(accountId, orderId, data) {
        return this.request({
            url: (0, apiRoutes_1.updatePayPalOrderUrl)(accountId, orderId),
            method: 'put',
            data,
        });
    }
    getContactPaymentDetails(accountId, orderId, params) {
        return this.request(Object.assign({ url: (0, apiRoutes_1.payPalContactPaymentDetailsUrl)(accountId, orderId), method: 'get' }, (params && { params: (0, excludeInvalidParams_1.excludeInvalidParams)(params) })));
    }
}
exports.PayPalService = PayPalService;
//# sourceMappingURL=index.js.map